module.exports = __webpack_public_path__ + "static/media/partly_cloudy_day.97938c01.svg";